import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { mockAuth, mockFirestore } from './mockAuth';

// Check feature flag for mock authentication
const useMockAuth = import.meta.env.VITE_USE_MOCK_AUTH === 'true';

// Check if we're in development mode and Firebase config is not set
const isFirebaseConfigured = import.meta.env.VITE_FIREBASE_API_KEY && 
  import.meta.env.VITE_FIREBASE_API_KEY !== "your-api-key";

// Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

let app: any = null;
let auth: any = null;
let db: any = null;

if (useMockAuth) {
  // Use mock services for development
  console.log('🔧 Using Mock Authentication for development');
  auth = mockAuth;
  db = mockFirestore;
} else if (isFirebaseConfigured) {
  try {
    // Initialize real Firebase only if properly configured
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app);
    console.log('🔥 Using Real Firebase Authentication');
  } catch (error) {
    console.error('Firebase initialization error:', error);
  }
} else {
  console.warn('Firebase not configured. Please set up your .env file with proper Firebase credentials.');
  console.warn('See FIREBASE_SETUP.md for instructions.');
}

// Export with fallbacks
export { auth, db };
export default app;

// Export mock flag for components that need it
export const IS_MOCK_MODE = useMockAuth; 